// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  font-family: "DM Sans", sans-serif;
  margin: 0;
  background-color: #edeeff !important;
  position: relative;
  counter-reset: dnd-step-counter;
}

main {
  background-color: #edeeff;
  overflow: auto;
  margin-bottom: 10em;
}

option {
  color: black;
}

.breadcrumb-container {
  background-color: #edeeff;
  width: 100%;
  height: 6vh;
}

.main-container {
  background-color: #edeeff;
  width: 100%;
  text-align: center;
  color: black;
}

.dashboard-first-section {
  padding-top: 3em;
  padding-bottom: 3em;
  background-color: #edeeff;
}

.dashboard-menu-item {
  min-width: 196px;
  min-height: 80px;
}

.dashboard-second-section {
  padding-top: 1em;
  padding-bottom: 1em;
  background-color: #727497;
  background-color: #727497;
  background-image: radial-gradient(#bacdce 2px, #727497 2px);
  background-size: 40px 40px;
  
  background: hsla(237, 100%, 96%, 1);
  background: linear-gradient(360deg, hsla(237, 100%, 96%, 1) 1%, hsla(237, 15%, 52%, 1) 100%);
  background: -webkit-linear-gradient(360deg, hsla(237, 100%, 96%, 1) 1%, hsla(237, 15%, 52%, 1) 100%);
  filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#EDEEFF", endColorstr="#727497", GradientType=1 );
}

.second-container {
  background-color: #f0f1f4;
  width: 100%;
  padding-top: 1em;
  padding-bottom: 1em;
}

.footer-container {
  background-color: #3d454f;
  color: #fff;
  text-align: center;
  height: 6vh;
  padding: 0.5em;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}


hr.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, lightgray, #ccc);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AACA;;EAEE,kCAAkC;EAClC,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,2DAA2D;EAC3D,0BAA0B;;EAE1B,mCAAmC;EACnC,4FAA4F;EAE5F,oGAAoG;EACpG,qHAAqH;AACvH;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;;AAGA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kEAAkE;AACpE","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\nbody,\nhtml {\n  font-family: \"DM Sans\", sans-serif;\n  margin: 0;\n  background-color: #edeeff !important;\n  position: relative;\n  counter-reset: dnd-step-counter;\n}\n\nmain {\n  background-color: #edeeff;\n  overflow: auto;\n  margin-bottom: 10em;\n}\n\noption {\n  color: black;\n}\n\n.breadcrumb-container {\n  background-color: #edeeff;\n  width: 100%;\n  height: 6vh;\n}\n\n.main-container {\n  background-color: #edeeff;\n  width: 100%;\n  text-align: center;\n  color: black;\n}\n\n.dashboard-first-section {\n  padding-top: 3em;\n  padding-bottom: 3em;\n  background-color: #edeeff;\n}\n\n.dashboard-menu-item {\n  min-width: 196px;\n  min-height: 80px;\n}\n\n.dashboard-second-section {\n  padding-top: 1em;\n  padding-bottom: 1em;\n  background-color: #727497;\n  background-color: #727497;\n  background-image: radial-gradient(#bacdce 2px, #727497 2px);\n  background-size: 40px 40px;\n  \n  background: hsla(237, 100%, 96%, 1);\n  background: linear-gradient(360deg, hsla(237, 100%, 96%, 1) 1%, hsla(237, 15%, 52%, 1) 100%);\n  background: -moz-linear-gradient(360deg, hsla(237, 100%, 96%, 1) 1%, hsla(237, 15%, 52%, 1) 100%);\n  background: -webkit-linear-gradient(360deg, hsla(237, 100%, 96%, 1) 1%, hsla(237, 15%, 52%, 1) 100%);\n  filter: progid: DXImageTransform.Microsoft.gradient( startColorstr=\"#EDEEFF\", endColorstr=\"#727497\", GradientType=1 );\n}\n\n.second-container {\n  background-color: #f0f1f4;\n  width: 100%;\n  padding-top: 1em;\n  padding-bottom: 1em;\n}\n\n.footer-container {\n  background-color: #3d454f;\n  color: #fff;\n  text-align: center;\n  height: 6vh;\n  padding: 0.5em;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n\n\nhr.style-one {\n  border: 0;\n  height: 1px;\n  background: #333;\n  background-image: linear-gradient(to right, #ccc, lightgray, #ccc);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
